import React from "react";

import {Row, Spinner} from "@deere/ux.uxframe-react";
import {useSelector} from "react-redux";

import {claimList, claimListFromClaimSearchForm, claimsError, claimsLoading,} from "./claimSearchSlice";
import {TextFilter, WtyReportTable,} from "../common/wty-report-table/WtyReportTable";
import {languageResponseData} from "../Translation/translationSerachSlice";

const ClaimList = ({searchFrom}) => {
    const claimsFromMachineDetails = useSelector(claimList);
    const claimsFromClaimForm = useSelector(claimListFromClaimSearchForm);
    const claimListLoading = useSelector(claimsLoading);
    const claimSearchError = useSelector(claimsError);

    const translationsResponse = useSelector(languageResponseData);
    const translate = (key, defaultText) => {
        return translationsResponse[key] || defaultText;
    };

    let claims;

    if (searchFrom === "ClaimSearchForm") {
        claims = claimsFromClaimForm;
    } else {
        claims = claimsFromMachineDetails;
    }

    const claimListColumns = [
        {
            Header: translate("dealer", "Dealer"),
            accessor: "dealer.dealerNumber",
            Filter: TextFilter,
        },
        {
            Header: translate("claim", "Claim#"),
            accessor: "claimNumber",
            Filter: TextFilter,
        },
        {
            Header: translate("type", "Type"),
            accessor: "claimType",
            Filter: TextFilter,
        },
        {
            Header: translate("fail_date", "Fail Date"),
            accessor: "failureDate",
            Filter: TextFilter,
        },
        {
            Header: translate("repair_date", "Repair Date"),
            accessor: "repairDate",
            Filter: TextFilter,
        },
        {
            Header: translate("process_date", "Process Date"),
            accessor: "processDate",
            Filter: TextFilter,
        },
        {
            Header: translate("Ref # 1", "Ref # 1"),
            Filter: TextFilter,
        },
        {
            Header: translate("Ref # 2", "Ref # 2"),
            accessor: "reference2",
            Filter: TextFilter,
        },
        {
            Header: translate("measurement", "Measurement"),
            accessor: "measurement",
            Filter: TextFilter,
        },
    ];

    return (
        <>
            {claimListLoading ? (
                <div className="uxf-spinner-border-inline mt-4">
                    <Spinner
                        className="uxf-spinner-border-sm"
                        animation="border"
                        accessibilityLabel="Loading claims"
                    />
                    <p aria-hidden="true" className="uxf-spinner-border-inline-text">
                        Loading claims...
                    </p>
                </div>
            ) : (
                <div>
                    {/*<Row style={{marginBottom: '1rem', justifyContent: 'center', alignItems: 'center'}}>
                            <Button variant="secondary" onClick={window.print}>Print to
                                Pdf</Button> &nbsp; &nbsp;
                            <ExportClaimList claims={claims}/>
                        </Row>*/}
                    <Row>
                        {claims && Array.isArray(claims) && claims.length > 0 ? (
                            <WtyReportTable
                                columns={claimListColumns}
                                data={claims}
                                dataType={"ClaimData"}
                                searchFrom={searchFrom}
                            />
                        ) : claimSearchError ? (
                            <span>
                {translate(
                    "message3",
                    "No Claim history found for this search criteria."
                )}
              </span>
                        ) : (
                            <></>
                        )}
                        {/*<Link
                                to={{
                                    pathname: `/claim-search/claimNumber/${claim.claimNumber}`,
                                    state: {
                                        searchFrom: searchFrom
                                    }
                                }}
                                onFocus={(e) => {
                                    e.target.style.color = 'grey';
                                }}
                            >
                                {claim.claimNumber}
                            </Link>*/}
                    </Row>
                </div>
            )}
        </>
    );
};

export default ClaimList;
